// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cWtp","badges":"styles_badges__2VftB"};